// src/store/userSlice.js
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { APIS } from 'constants/api.constant';
import { getApi } from 'services/CommonService';

// 1. The Fetch Function (Async Thunk)
export const fetchUserDetail = createAsyncThunk(
  'profile/fetchUserDetail',
  async (_, { rejectWithValue }) => {
    try {
      // Replace with your actual API call
      const data = await getApi(APIS.PROFILE)
     
      return data; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    info: null,      // This holds your user details
    loading: false,
    error: null,
  },
  reducers: {
    // 2. The Edit Function (Synchronous update to Redux state)
    editUserDetails: (state, action) => {
      if (state.info) {
    Object.assign(state.info.data, action.payload);
      } else {
         
        state.info = action.payload; 
      }
    },
    // Optional: Clear user on logout
    clearUser: (state) => {
      state.info = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.info = action.payload; // Stores fetched data in state
      })
      .addCase(fetchUserDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { editUserDetails, clearUser } = profileSlice.actions;
export default profileSlice.reducer;